type EventCallback = (data: any) => void;

class EventManager {
    private subscribers: { [eventType: string]: { [id: string]: EventCallback[] } };

    constructor() {
        this.subscribers = {};
    }

    subscribe(eventType: string, id: number | null, callback: EventCallback): void {
        const idKey = id?.toString() ?? 'global';

        if (!this.subscribers[eventType]) {
            this.subscribers[eventType] = {};
        }
        if (!this.subscribers[eventType][idKey]) {
            this.subscribers[eventType][idKey] = [];
        }

        this.subscribers[eventType][idKey].push(callback);
    }

    unsubscribe(eventType: string, id: number | null, callback: EventCallback): void {
        const idKey = id?.toString() ?? 'global';

        if (this.subscribers[eventType] && this.subscribers[eventType][idKey]) {
            this.subscribers[eventType][idKey] = this.subscribers[eventType][idKey].filter(cb => cb !== callback);
        }
    }

    publish(eventType: string, id: number | null, data: any): void {
        const idKey = id?.toString() ?? 'global';

        if (this.subscribers[eventType] && this.subscribers[eventType][idKey]) {
            this.subscribers[eventType][idKey].forEach(callback => callback(data));
        }
    }
}

export default new EventManager();
